module.exports = __webpack_public_path__ + "static/luigi-c18ed2d0f6696451ca5d19fadf18307d.jpg";